import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useMemo, useState } from "react";
import {
    ITopology,
  useDeleteTopologyMutation,
  useGetTopologiesQuery,
} from "../../app/apiSlice";
import { setToast } from "../../app/appSlice";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { useSecureApplication } from "../../hooks/KeycloackConnection";
import { paginationForBack } from "./paginationForBack";
import { setParamTopologyPagination } from "./TreatmentSlice";
import { Dialog } from "primereact/dialog";
import { useTranslation } from 'react-i18next';

interface FooterDialog  {
  topology: ITopology,
  setDialogVisibility:(dialogVisibility:boolean) => void
}

export const FooterDialog = ({setDialogVisibility, topology}: FooterDialog) => {
  const [deleteTopology, { ...deleteStatus }] = useDeleteTopologyMutation();
  const dispatch = useAppDispatch();
  const paramPagination = useAppSelector(
    (state) => state.treatment.paramTopologiesPagination
  );
  const setPaginationForBack = useMemo(
    () => paginationForBack(paramPagination),
    [paramPagination]
  );

  const { data, ...status } = useGetTopologiesQuery(setPaginationForBack);

  return (
    <div style={{ float: "right" }}>
      <Button
        label={"ANNULER"}
        onClick={() => setDialogVisibility(false)}
        className="mr-3 p-button-outlined p-button-sm"
      />

      <Button
        id="hook-form"
        onClick={async () => {
          try {
            await deleteTopology({ id: topology.id }).unwrap();
            dispatch(setToast({
              title: ``,
              content: `Suppression du traitement "${topology.name}"`,
              severity: "success",
              life: 6000,
            }));

            if (data?.topologies.length === 1 && paramPagination.page >= 1) {
              dispatch(
                setParamTopologyPagination({
                  ...paramPagination,
                  page: paramPagination.page - 1,
                })
              );
            } else {
              status.refetch();
            }
          } catch (e: any) {
            let message = `Echec de la suppression de ${topology.name}`;
            if (e.status === 409) {
              message = `Echec de la suppression de ${topology.name} car au moins une version de ce traitement existe`;
            } else if (e.status === 473) {
              message = `Au moins une instance du traitement "${topology.name}" est en cours d'exécution !`;
            }
            dispatch(
              setToast({
                title: `Suppression impossible`,
                content: message,
                severity: "error",
                life: 6000,
              })
            );
          }
          setDialogVisibility(false);
        }
      }
        type="submit"
        label={"SUPPRIMER"}
        className="p-button-danger p-button-sm"
      >
        {deleteStatus.isLoading ? (
          <FontAwesomeIcon className="ml-2" icon="spinner" spin />
        ) : null}
      </Button>
    </div>
  );
};

export const DeleteTopology = ({ topology }: { topology: ITopology }) => {
  const { hasAnyPerm } = useSecureApplication();
  const [dialogVisibility, setDialogVisibility] = useState<boolean>(false);
  const {t: translate} = useTranslation();

  return (
    <>
      <Dialog
          header={'Supprimer'}
          visible={dialogVisibility}
          className={'app-dialog mr-3'}
          onHide={() => {
            setDialogVisibility(false);
          }}
          footer={<FooterDialog setDialogVisibility={(dialogVisibility) => {
            setDialogVisibility(dialogVisibility)
          }} topology={topology}></FooterDialog>}
      >
        <div className="mb-3 flex flex-column">
          <span>{translate('message.treatment.delete-confirmation')}<span className="font-bold">{topology.name}</span> ? </span>
          <span>{translate('message.treatment.delete-help')}</span>
        </div>
      </Dialog>
      <Button
          className="p-button-text"
          icon="pi pi-trash"
          title={'Supprimer'}
          disabled={!hasAnyPerm('pipelines.all', 'pipelines_del')}
        onClick={() => {
          setDialogVisibility(true);
        }}
      ></Button>
    </>
  );
};





